import { ExternalUserFormDto, type ExternalUserFormInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-form.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';
import { SecurityBackendValidatorsEnum } from '@zaoblako/shared/modules/security/enums/security-backend-validators.enum';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { booleanSchema } from '@zaoblako/shared/modules/serde/schemas/boolean.schema';
import type { ProfileFindInterface } from '@zaoblako/shared/modules/security/dtos/profile/profile-find.dto';

/** External user create request body */
export interface ExternalUserCreateInterface extends ExternalUserFormInterface {
  /** Profile this external user belongs to */
  profile: ProfileFindInterface;
  /** Invite profile to tenant as external user */
  invite?: boolean;
}

/** External user create request body - DTO schema */
export const ExternalUserCreateDto = SerdeDtoClass.from<ExternalUserFormInterface, ExternalUserCreateInterface>(
  ExternalUserFormDto,
  SecurityDtoKeysEnum.EXTERNAL_USER_CREATE_DTO,
  {
    profile: {
      label: 'Профиль',
      checkers: [SecurityBackendValidatorsEnum.PROFILE_ASSERT_EXISTS_BY_DTO],
      serializer: entityLikeSchema,
    },
    invite: {
      optional: true,
      label: 'Отправить приглашение',
      serializer: booleanSchema,
    },
  },
);
